import { inject, Injectable } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/internal/operators/catchError'
import { AuthService } from '../services/auth.service'
import { LocalStorageService } from '../services/local-storage.service'

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private localStorageService: LocalStorageService = inject(LocalStorageService)
  private authService: AuthService = inject(AuthService)

  private addToken(httpRequest: HttpRequest<any>, token: string) {
    return httpRequest.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    })
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const split = request.url.split('/');
    // const isRefresh = split[split.length - 1].includes('refresh');
    const token = this.localStorageService.getItem('token')

    if (token) {
      request = this.addToken(request, token)
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401 && token) {
            const url = request.url
            const isAuthEndpoint = url.includes('/auth/login') || url.includes('/auth/refresh')
            
            const errorData = error.error
            let isBlockedUser = false

            if (errorData?.errors && Array.isArray(errorData.errors)) {
              isBlockedUser = errorData.errors.some((err: any) => 
                err.message === 'auth.blocked' || err.value === 'auth.blocked'
              )
            } else if (errorData?.message) {
              isBlockedUser = errorData.message === 'auth.blocked' || 
                             (Array.isArray(errorData.message) && 
                              errorData.message.some((msg: any) => 
                                msg === 'auth.blocked' || msg.value === 'auth.blocked'
                              ))
            }

            if (isBlockedUser || url.includes('/auth/user')) {
              this.authService.logout()
              return throwError(() => error)
            }
          }
        }
        return throwError(() => {
          return error
        })
      }),
    )
  }
}
